"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _utils = require("../../utils");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function useMenuItem(options) {
  var itemOption = options.item,
      variant = options.variant; // The type of the item is related to the kind of menu item that needs to be rendered.

  var _useMemo = (0, _react.useMemo)(function () {
    if (variant === 'sub' && (0, _utils.isMenuSubItem)(itemOption)) {
      // the item is a sub item, being rendered under a top level menu item.
      return [itemOption, 'MenuSubItem'];
    }

    if ((0, _utils.isMenuItemTopLink)(itemOption)) {
      if ((0, _utils.isMenuItemTopWithSubItems)(itemOption)) {
        return [itemOption, 'MenuItemTopLinkWithSubItems'];
      }

      return [itemOption, 'MenuItemTopLink'];
    }

    return [itemOption, 'MenuItemTopWithSubItems'];
  }, [itemOption, variant]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      item = _useMemo2[0],
      kind = _useMemo2[1];

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var toggleExpanded = (0, _react.useCallback)(function () {
    setExpanded(!expanded);
  }, [expanded, setExpanded]);
  return (0, _react.useMemo)(function () {
    return {
      expanded: expanded,
      item: item,
      kind: kind,
      setExpanded: setExpanded,
      toggleExpanded: toggleExpanded
    };
  }, [expanded, item, kind, setExpanded, toggleExpanded]);
}

var _default = useMenuItem;
exports.default = _default;